<!-- 用户中心页 -->
<template>
	<div>
		<!-- 用户头像和昵称区 -->
		<van-row type="flex"  align="center" class="user-bg">
		  <van-col span="5" offset="1">
			  <van-image class="user-profile" width="60" height="60" round  :src="user.head_image?user.head_image:require('../../assets/logo.png')"/>
		 </van-col>
		 <van-col span="12">
			 <div v-if="token">
				 <div class="user-name white"  @click="changeUserInfo">{{user.user_name}} <span><van-icon name="edit" /></span></div>
				 <div v-if="user.mobile" class="ad-title white">{{user.mobile}}</div>
				 <div v-else class="ad-title white" @click="openDialog" style="text-decoration: underline;">绑定手机号</div>
				 <van-dialog v-model="show" title="绑定手机号" show-cancel-button @confirm="bindMb">
					<van-field v-model="tel" type="tel" label="手机号"  placeholder="请输入手机号" label-width='3.2em' />
					<van-field
					  v-model="code"
					  clearable
					  label="验证码"
					  placeholder="请输入验证码"
					  label-width='3.2em'
					  maxlength='6'
					  type='number'
					>
					  <template #button>
					    <van-button v-show="issend" size="small" type="primary"  @click="sendBindPhoneCode">获取验证码</van-button>
						<van-button v-show='!issend' size="small" type="primary" disabled=true >{{count}} s后重发</van-button>
					  </template>
					</van-field>
				</van-dialog>
			 </div>
			 <div v-else>
				 <div @click="wxlogin" class="user-name white">点击登录</div>
				 <div class="ad-title white">立即开团~</div>	 
			</div>
		 </van-col>
		 <!-- <van-col span="5" offset="1" v-if="token">
			  <div class="white" style="margin-right: 20px;">拼团会员</div>
		  </van-col> -->
		</van-row>
		<!-- 我的订单 -->
		<div style="background-color: #42C052 ;padding: 10px;">
			<div class="user-order">
				<div class="user-order-title">我的订单</div>
				<van-grid clickable :column-num="5" style="color: #42C052;">
				  <van-grid-item  v-for="(item,index) in items" :key="index" :icon="item.icon" :text='item.text' @click="goOrder(item.text)"/>
				</van-grid>
			</div>
		</div>
		<!-- 常用工具 -->
		<div class="user-order-title" style=" margin:10px 0;padding-left: 30px;">常用工具</div>	
		<van-grid clickable :column-num="4" style="color: #42C052;">
		  <van-grid-item icon="brush-o" text="退出登录" @click="clear" v-if="token" />
		  <van-grid-item icon="contact" text="联系客服"  @click='gowx'/>
		  
		  
		</van-grid>
		
		<van-tabbar route placeholder safe-area-inset-bottom active-color="#42C052">
		   <van-tabbar-item replace to='/activityList' icon="home-o">首页</van-tabbar-item>
		   <van-tabbar-item replace to="/cart" icon="cart-o" :badge="cartTotalNum>0 ? cartTotalNum :''">购物车</van-tabbar-item>
		   <van-tabbar-item replace to="/userCenter" icon="user-o">我的</van-tabbar-item>
		 </van-tabbar>
		 
		<van-dialog v-model="userInfoShow" title="修改用户昵称" show-cancel-button @confirm='userInfoSubmit' close-on-click-overlay>
		  <van-form style="padding: 10px 0;">
		    <van-field
		      v-model="newUserName"
		      name="昵称"
		      label="昵称:"
		      :placeholder="user.user_name"
		    />
			</van-form>
		</van-dialog> 
		 
	</div>
</template>

<script>
	import {mapState,mapGetters,mapMutations,} from 'vuex'	
	export default{
		name:"useCenter",
		data(){
			return{
				items:[
					{icon:'balance-list-o',text:'待支付',},
					{icon:'todo-list-o',text:'待提货',},
					{icon:'completed',text:'已完成',},
					{icon:'refund-o',text:'退款售后',},
					{icon:'orders-o',text:'全部',}
				],
				show:false,//绑定手机号弹窗
				tel:'',//手机号码
				issend:true,//是否已发送标识
				count:'',//倒计时
				timer:null,//计数器
				code:'',//验证码
				userInfoShow:false,//用户信息弹窗
				newUserName:''//新用户名
			}
		},
		methods:{
			...mapMutations(['removeToken','setToken','removeUserToken','isLogin','setUserToken']),
				wxlogin(){						
					this.$wxLogin()	;
					//localStorage.setItem("isPreRoute", false);
					
				},
				clear(){
					this.$dialog.confirm({
					  title: '退出登录',
					  message: '清除缓存并退出登录',
					})
					  .then(() => {
						this.removeToken()
						this.removeUserToken()
						this.$notify({
						  type:"danger",
						  message: '退出登录',
						  duration: 1000,
						})
					  })
					  .catch(() => {
					    
					  });
				},
				goOrder(name){
					if(this.token){
						//跳转售后页面
						if(name == '退款售后'){
							this.$router.push({
								path:'/returnOrderList',								
							})
						}else{
							this.$router.push({
								path:'/orderList',
								query:{
									name:name
								}
							})
						}
						
					}
					else{
						this.$notify({
						  type:"danger",
						  message: '请先登录!',
						  duration: 2000,
						})
					}
					
				},
				contact(){
					this.$dialog.alert({
					  message: '请关注微信公众号：拥军惠民农产品平台',
					}).then(() => {
					  // on close
					});
				},
				openDialog(){
					this.show=true
				},
				//绑定手机号
				bindMb(){

					if(this.tel=='' || this.code ==''){
						this.$notify({
						  type:"danger",
						  message: '请检查手机号或验证码!',
						  duration: 1000,
						})
						return
					}
					this.request.postURL('/api/user/bindPhone',{
						mobile:this.tel,
						code:this.code
					}).then(res=>{
						let user=this.user
						user.mobile=this.tel
						this.setToken(res.data.data.token);//更新缓存
						this.setUserToken(user);//更新用户信息
						this.$notify({
						  type:"primary",
						  message: '绑定手机号成功!',
						  duration: 1000,
						})
						//this.$store.commit('setBindPhone');
						// const curr = localStorage.getItem('preRoute')
						// if (curr && this.$state.goBindPhone) {
						// 	this.$router.push({ path: curr });
						// }
					}).catch(err=>{
						console.log(err)
						this.$notify({
						  type:"danger",
						  message: err,
						  duration: 1000,
						})
					})
				},
				//发送验证码
				sendBindPhoneCode(){
					this.request.postURL('/api/user/sendBindPhoneCode',{
						mobile:this.tel
					}).then(res=>{
						this.getCode()			
					}).catch(err=>{
						//console.log(err)
						this.$toast(err.msg)
					})
				},
				//验证码计时器
				getCode(){
				    const TIME_COUNT = 60;
					if (!this.timer) {
					this.count = TIME_COUNT;
					this.issend = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
							} else {
							this.issend = true;
							clearInterval(this.timer);
							this.timer = null;
							}
						}, 1000)
					}
				},
				gowx(){
					this.$dialog.confirm({
					  title: '联系客服',
					  message: '您可以到公众号菜单联系客服！',
					})
					  .then(() => {
					    window.location.replace('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI3NTAxMjY2NQ==&scene=124#wechat_redirect')
					  })
					  .catch(() => {
					    // on cancel
					  });
					
				},
				//更改用户信息弹窗
				changeUserInfo(){
					if(!this.token){
						return 
					}
					this.newUserName = ''
					this.userInfoShow = true
				},
				//更改用户信息
				userInfoSubmit(){
					if(!this.newUserName){
						return
					}
				    this.request.postURL('/api/user/updateOwnInfo',{
						user_name:this.newUserName,
					}).then(res=>{					
						let user=this.user
						user.user_name=this.newUserName
						
						this.setUserToken(user);//更新用户信息
						
						
						if(res.data.code==1){
							this.$notify({
							  type:"primary",
							  message: '修改用户信息成功！',
							  duration: 1000,
							})
						}else{
							this.$notify({
							  type:"error",
							  message: res.msg,
							  duration: 1000,
							})
						}
						
					}).catch(function (err) {
					   console.log(err)
					  });
				}
			},
		computed:{
			  ...mapState(['user','token','cartTotalNum']),
		},
		created() {
		
		},
		// beforeRouteEnter(to,from,next){
		// 	next()
		// 	let curr = localStorage.getItem('preRoute') ? localStorage.getItem('preRoute') :''
		// 	let isPre = localStorage.getItem('isPreRoute') ? localStorage.getItem('isPreRoute') :false
		// 	if(from.path =='/weChat' && isPre){	
		// 		setTimeout(function(){
		// 			next(curr)
		// 		},500)	
				
		// 	}				
		// }
	}
</script>

<style>
	.white{
		color: #fff;
	}
	.user-bg{
		/* background-color: #E74C3C; */
		background-color: #42C052;
		padding: 50px 0;
	}
	.user-profile{
		border: 2px solid #ffffff;
		
	}
	.user-name{
		font-size: 16px;
		text-align: left;
	}
	.ad-title{
		font-size: 14px;
		text-align: left;
		margin-top: 5px;
	}
	.user-order-title{
		font-size: 16px;
		font-weight: 550;
		text-align: left;
		padding: 5px 20px;
	}
	.user-order{
		background-color: #ffffff;
		border-radius: 10px;
	}
</style>
